import {fastQuery, cdrQuery, checkNotify} from 'api/fastQuery';
import Cookies from 'js-cookie';

const fastquery = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        //test
        fastQuery({commit},keyword) {
            return new Promise((resolve, reject) => {
                fastQuery(keyword).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        cdrQuery({commit}, params) {
            return new Promise((resolve, reject) => {
                var time = params.time;
                var pagesize = params.psize;
                var page = params.currentPage;
                var imsi = params.imsi;
                cdrQuery(time, pagesize,page,imsi).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        checkNotify({commit}) {
            return new Promise((resolve, reject) => {
                checkNotify().then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default fastquery;



// WEBPACK FOOTER //
// ./src/store/modules/fastQuery.js